var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "card p-3" },
          [
            _c(
              "b-card",
              [
                _c(
                  "b-card-title",
                  [
                    _c("b-row", [
                      _c("h3", { staticClass: "text-center" }, [
                        _vm._v("Pedido Mínimo")
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-card-body",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          disabled: _vm.perfil !== "adm",
                          variant: "success",
                          size: "sm"
                        },
                        on: { click: _vm.adicionarClasse }
                      },
                      [_vm._v("Adicionar Classe")]
                    ),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-bordered table-striped text-center"
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Classe")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Restrição em")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Valor Mínimo")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Qtd. Pedidos Mínimo")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Qtd. Mínima de itens")
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v(" ")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.restricoes, function(restricao) {
                            return _c("tr", { key: restricao.classe }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    restricao.classe == "U"
                                      ? "Não Listada"
                                      : restricao.classe
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatarLabelRestricao(
                                      restricao.restricao
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    restricao.restricao === "VALOR"
                                      ? "R$ " + restricao.valor + ",00"
                                      : restricao.valor
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(restricao.quantidade_pedido))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(restricao.itens))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        title: "Editar Regra",
                                        size: "sm"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.showModal(restricao.id)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-edit" })]
                                  )
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("blockquote", { staticClass: "blockquote" }, [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      'Quando não houver um valor mínimo para a Classe do Distribuidor, o valor "Não Listada" será utilizado.'
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.update.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.openedModal = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedModal,
            callback: function($$v) {
              _vm.openedModal = $$v
            },
            expression: "openedModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-card-title",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "3" } },
                        [
                          _c("label", { attrs: { for: "class" } }, [
                            _vm._v("Classe:")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              disabled: !_vm.novaClasse,
                              id: "class",
                              placeholder: "Informe a Classe",
                              "v-mask": "SS"
                            },
                            model: {
                              value: _vm.classe,
                              callback: function($$v) {
                                _vm.classe = $$v
                              },
                              expression: "classe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card-body",
                [
                  _c("b-row", [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Parâmetro para Valor Mínimo")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.tipo,
                              expression: "tipo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "", id: "" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.tipo = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "ITEM" } }, [
                            _vm._v(" Quantidade de Ítens")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "PRODUTO" } }, [
                            _vm._v(" Quantidade de Produtos")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "VALOR" } }, [
                            _vm._v("Valor em Reais (R$)")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Limite Mínimo:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "######",
                            expression: "'######'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.valor,
                            expression: "valor"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.valor },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.valor = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Quantidade mínima de Pedidos :")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "##",
                            expression: "'##'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quantidade,
                            expression: "quantidade"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.quantidade },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quantidade = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Quantidade mínima de Itens :")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "####",
                            expression: "'####'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.itens,
                            expression: "itens"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.itens },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.itens = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Data de Fechamento :")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group col-md-6" },
                      [
                        _c("date-picker", {
                          attrs: { config: _vm.datePickerConfig },
                          model: {
                            value: _vm.data_fechamento,
                            callback: function($$v) {
                              _vm.data_fechamento = $$v
                            },
                            expression: "data_fechamento"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Data de Fechamento "),
                        _c("small", [_vm._v("(Centro Distribuição)")]),
                        _vm._v(" :")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group col-md-6" },
                      [
                        _c("date-picker", {
                          attrs: { config: _vm.datePickerConfig },
                          model: {
                            value: _vm.data_fechamento_cd,
                            callback: function($$v) {
                              _vm.data_fechamento_cd = $$v
                            },
                            expression: "data_fechamento_cd"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Exceção a regra do pedido Mínimo", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-3",
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.saveRegra }
                    },
                    [_vm._v("Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-3",
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.openedRules = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedRules,
            callback: function($$v) {
              _vm.openedRules = $$v
            },
            expression: "openedRules"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Digite o nome e selecione")]),
                        _vm._v(" "),
                        _c("v-select", {
                          attrs: {
                            options: _vm.distribuidores,
                            onSearch: _vm.loadDistribuidor
                          },
                          model: {
                            value: _vm.distribuidor,
                            callback: function($$v) {
                              _vm.distribuidor = $$v
                            },
                            expression: "distribuidor"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18b093cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b093cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedido_minimo/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-18b093cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedido_minimo/Main.vue
// module chunks = 2